import PolicyPage from '../components/PolicyPage';

const CookiesPolicyPage = () => {
  return (
    <PolicyPage 
      title="Cookies Policy"
      metaTitle="Cookies Policy - Website Cookie Usage"
      metaDescription="Understand how Golden Tree Events uses cookies on our website. Covers types of cookies, tracking technologies, cookie preferences, and how to manage or disable cookies."
      sourceUrl="https://gtedubai.com/app/cookies-policy?awd=gte"
    />
  );
};

export default CookiesPolicyPage;
